import { NgModule } from '@angular/core';

import { FooterComponent } from './footer.component';
import { SharedModule }    from '../shared/shared.module';

@NgModule({
  declarations: [
    FooterComponent
  ],
  entryComponents: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ],
  imports: [
    SharedModule
  ]
})
export class FooterModule {}
